class SearchForm {
  static init() {
    const searchButton = document.querySelector('form[role="search"] svg.nzr--search-magnifier');
    if (searchButton) {
      searchButton.addEventListener('click', function (evt) {
        document.querySelector('form[role="search"]').submit();
      });
    }
  }
}

export default SearchForm;
